import { IColumns } from '../../../../../../../components/Dashboard/Table'

export const columns: IColumns[] = [
  {
    id: 'currency',
    label: 'Currency',
  },
  {
    id: 'address',
    label: 'Address',
  },
  {
    id: 'status',
    label: 'Status',
  },
]
